const formatDollars = (x) => x.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD' // You can change the currency code as needed
});

export default formatDollars;